import React from 'react'
import Stepper from '../shared/stepper.js'
import ModalError from '../shared/modal_errore.js'
import moment from 'moment';
import ToggleContainer from '../shared/toggle_container.js'
import CTA from '../shared/cta.js'
import RecapArea from "../shared/recap_area.js";
import { connect } from 'react-redux';
import { clearFiliali } from "../../actions/index";
import { setDove } from "../../actions/index";
import { setGiorno, clearHistoryBack, setFirstLoad, setRicontattoCf, setRicontatto } from "../../actions/index";
import { setFiliali } from "../../actions/index";
import { setFiliale } from "../../actions/index";
import { setOrario } from "../../actions/index";
import { setFilialeRicontatto, setOverlay, setDatiPersonali, setConsensi, setTipoAppuntamento, setVecchioAppuntamento, setOppID, setFlussoModifica, setRecap, setProdotto, setCapExcluded, setTelefonico, setFlowSwitch } from "../../actions/index";
import utils from "../../modules/utils";
import { translateCap } from "../../modules/location";
import apiInvoker from "../../modules/apiInvoker";
import './dove.css'
import { handleGeolocalization, handleLocationInteraction, handleCap } from "../../modules/datalayer.js"
import { trackPageView, startDigitalAssistant } from "../../modules/datalayer.js"
import ModalBoxGenerico from '../shared/modal_box_generico.js'
/* Mocks */
import { excludedCapsMock } from '../../modules/mocks/excludedCaps';
/* Flow */
import { handleFlow, enterInSpecificFlow, switchToPrestitoPersonale } from '../../flow/flow';

const mapDispatchToProps = dispatch => {
  return {
    setAppointmentType: (type) => dispatch(setTipoAppuntamento(type)),
    clearFiliali: () => dispatch(clearFiliali()),
    setFiliali: (f) => dispatch(setFiliali(f)),
    setDove: (location) => dispatch(setDove(location)),
    setGiorno: (giorno) => dispatch(setGiorno(giorno)),
    setFiliale: (fil) => dispatch(setFiliale(fil)),
    setOrario: (fil) => dispatch(setOrario(fil)),
    clearHistoryBack: (c) => dispatch(clearHistoryBack(c)),
    setProdotto: (c) => dispatch(setProdotto(c)),
    setCapExcluded: (c) => dispatch(setCapExcluded(c)),
    setTelefonico: (t) => dispatch(setTelefonico(t)),
    setFirstLoad: (t) => dispatch(setFirstLoad(t)),
    setDatiPersonali: (payload) => dispatch(setDatiPersonali(payload)),
    setConsensi: (payload) => dispatch(setConsensi(payload)),
    setVecchioAppuntamento: (payload) => dispatch(setVecchioAppuntamento(payload)),
    setOppID: (payload) => dispatch(setOppID(payload)),
    setFlussoModifica: (payload) => dispatch(setFlussoModifica(payload)),
    setRecap: (payload) => dispatch(setRecap(payload)),
    setFlowSwitch: (payload) => dispatch(setFlowSwitch(payload)),
    setOverlay: (payload) => dispatch(setOverlay(payload)),
    setRicontattoCf: (payload) => dispatch(setRicontattoCf(payload)),
    setRicontatto: (payload) => dispatch(setRicontatto(payload)),
    setFilialeRicontatto: (payload) => dispatch(setFilialeRicontatto(payload)),
  }
}

class Dove extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      errors: {},
      appuntamentoNonTrovatoVisibile: false,
      forced_location: '',
      recapAreaVisibility: false,
      toggleContainerTitle: "Cerca la tua filiale",
    }

    this.trovaFiliali = this.trovaFiliali.bind(this);
    this.handleKeyup = this.handleKeyup.bind(this);
    this.closeModalGenerica = this.closeModalGenerica.bind(this);
    this.setRecapAreaVisibility = this.setRecapAreaVisibility.bind(this);
    this.setToggleContainerTitle = this.setToggleContainerTitle.bind(this);
    this.userDataExists = this.userDataExists.bind(this);
    this.appointmentDataExists = this.appointmentDataExists.bind(this);
    this.retrieveUserData = this.retrieveUserData.bind(this);
    this.retrieveOldAppointment = this.retrieveOldAppointment.bind(this);
  }
  componentDidMount() {
    const telefonico_forzato = window.location.pathname == "/fissa-appuntamento/scegli-dove";
    const reduxState = utils.getState();

    this.props.setDove('');
    if (!telefonico_forzato) {
      trackPageView('scegli-luogo');
    } else {
      this.props.setProdotto(-2);
      this.props.setTelefonico(true);
      this.props.setFirstLoad();
      trackPageView('scegli-dove');
    }
    startDigitalAssistant(); //Ripristino il DA in caso di back
    utils.animate.fadeIn();
    utils.animate.slideIn(utils.getState().dati_locali.historyBack);
    this.props.clearHistoryBack();

    this.setRecapAreaVisibility(reduxState.prodotto);
    this.setToggleContainerTitle(reduxState.prodotto);

    if (reduxState.modificando) {
      const { vecchio_appuntamento: vecchioAppuntamento } = reduxState.dati_locali;

      this.setState({
        forced_location: vecchioAppuntamento.luogo,
      });

      this.props.setFlowSwitch({
        goToNextStepAutomatically: true,
        previousFlow: reduxState.prodotto,
      });

      this.props.setOverlay(
        {
          loader: {
            isVisible: true,
          }
        }
      );
    }
  }

  componentDidUpdate() {
    if (this.state.isOpen === true) {
      window.$('html,body').animate({
        scrollTop: (window.$(".toggle-container").offset().top + window.$(".toggle-container").height() / 2) - 300
      })
    }
  }

  setRecapAreaVisibility(product = 0) {
    this.setState({
      recapAreaVisibility: product == 3,
    });
  }

  setToggleContainerTitle(product = 0) {
    if (product == 3) {
      this.setState({
        toggleContainerTitle: "Cerca la tua Agenzia"
      });
    }
  }

  userDataExists(appointment) {
    if (appointment) {
      const {utente} = appointment;
  
      if (utente) {
        if (utente.impiego==null) {
          utente.impiego = "4";
        }
        const filteredKeys = Object.keys(utente).filter(key => {
          return key !== 'codice_fiscale' && key !== 'consensi' && key !== 'cap';
        });
        const valuesList = filteredKeys.map(key => utente[key]);
  
        if (valuesList.every(value => typeof value === "number" ? !isNaN(value) : value)) {
          return true;
        }
      }
    }

    return false;
  }

  appointmentDataExists(appointment) {
    if (appointment) {
      const valuesList = Object.values(appointment);

      if (valuesList.every(value => typeof value === "number" ? !isNaN(value) : value)) {
        return true;
      }
    }

    return false;
  }

  retrieveUserData(appointment) {
    const { utente } = appointment;

    if (utente) {
      this.props.setDatiPersonali({
        nome: utente.nome,
        cognome: utente.cognome,
        email: utente.email,
        telefono: utente.telefono,
        cap:
          utente.cap && utente.cap != ""
            ? utente.cap
            : "99999",
        impiego: utente.impiego
      });

      if (utente.consensi) {
        this.props.setConsensi({
          informativa: utente.consensi.informativa,
          dati_personali: utente.consensi.dati_personali,
          societa_terze: utente.consensi.societa_terze,
        });
      }
    }
  }

  retrieveOldAppointment(appointment) {
    const { oppID, prodotto, luogo, coordinate_luogo: coordinateLuogo, data_appuntamento: dataAppuntamento, orario_appuntamento: orarioAppuntamento, filiale, id_filiale: idFiliale, indirizzoFiliale } = appointment;
    
    this.props.setVecchioAppuntamento(appointment);
    this.props.setOppID(oppID);
    this.props.setFlussoModifica(true);

    this.props.setRecap(true);
    this.props.setProdotto(prodotto);
    this.props.setDove({
      luogo: luogo,
      coordinate_luogo: coordinateLuogo
    });
    this.props.setGiorno(utils.setDateFormat(dataAppuntamento));
    this.props.setOrario(orarioAppuntamento);
    this.props.setFiliale({
      id: utils.padLeft3(idFiliale),
      nome: filiale,
      indirizzo: indirizzoFiliale
    });
  }

  trovaFiliali(location, lat, lng, cap, options) {
    let self = this;
    const global_state = utils.getState();
    let payload = {
      Coordinate: {
        lat,
        lng,
      },
      Cap: cap,
      TipoFiliali: 0
    };

    if (global_state.tipo_appuntamento == "fast") {

      this.props.setGiorno('-1');
      this.props.setFiliale({ id: '-1', nome: 'loading', indirizzo: '' });
      this.props.setOrario('-1');
    }

    /*//Svuoto le filiali
    this.props.setFiliali({
        'filiali': {}
    })*/
    this.props.clearFiliali();

    if (global_state.prodotto == 3) {
      payload = {
        ...payload,
        TipoFiliali: 1,
      };
    }

    apiInvoker.TrovaFiliali(payload, res => {
      if (res.status == 200) {
        let filiali = res.data;

        if (filiali.length) {
          const prima_filiale = filiali[0];

          if (prima_filiale && prima_filiale.hasOwnProperty("ricontatto") && prima_filiale.ricontatto == true) {
            self.props.setRicontatto(true);
            self.props.setFilialeRicontatto(prima_filiale.codFilialeCL);
          }

          self.props.setFiliali({
            'filiali': filiali,
            'filiale_selezionata': prima_filiale.idFiliale,
            'nome_filiale_selezionata': prima_filiale.nomeFiliale
          });
  
          if (global_state.tipo_appuntamento == "fast") {
            let disp_trovata = false;
            for (let i = 0; i < filiali.length; i++) {
              let fil = filiali[i];
              if (fil.disponibilita) {
                for (let z = 0; z < fil.disponibilita.length && disp_trovata == false; z++) {
                  let disp = fil.disponibilita[z];
                  if (disp.orariDisponibili.length > 0) {
                    for (let oraAvailable = 0; oraAvailable < disp.orariDisponibili.length && disp_trovata == false; oraAvailable++) {
                      let orarioDisp = disp.orariDisponibili[oraAvailable];
                      if (orarioDisp.disponibile === true) {
                        disp_trovata = true;
                        let giorno = moment(disp.giorno).format("YYYY-MM-DD");
                        let ora = moment(orarioDisp.hour + ":" + orarioDisp.minute, "HH:mm").format("HH:mm");
                        self.props.setGiorno(giorno);
                        self.props.setFiliale({ id: fil.idFiliale, nome: fil.nomeFiliale, indirizzo: fil.indirizzo });
                        self.props.setOrario(ora);
                      }
                    }
                  }
                }
                if (disp_trovata) {
  
                  break;
                }
              }
            }
            if (!disp_trovata) {
              if (options && options.goToNextPage) {
                options.goToNextPage = false;
              }
              
              self.props.setFiliale('');
              self.props.setOrario('');
              self.props.setGiorno('');
              self.props.setAppointmentType("standard");
              handleFlow();
            }
          }

          if (options && options.goToNextPage) {
            handleFlow();
          }
        } else {
          // Check CF
          const reduxState = utils.getState();
          const { utente } = reduxState;
          
          if (utente && utente.codice_fiscale) {
            const codiceFiscale = utente.codice_fiscale;

            apiInvoker.CheckByCF(
              codiceFiscale,
              "",
              (response) => {
                if (res.status == 200) {
                  const { data: responseBody } = response;
  
                  if (responseBody && responseBody.status == 200) {
                    let { appuntamento } = responseBody;


                    if (responseBody.hasOwnProperty('ricontatto') && responseBody.ricontatto == true) {
                      self.props.setRicontattoCf(responseBody.ricontatto);
                      //utils.redirectToFa3(codiceFiscale, { 'lat': lat, 'lng': lng }, location);
                      //return false;
                    }

                    //TODO: check if correct
                    /*if (appuntamento && appuntamento.utente) {
                      appuntamento.utente = utils.getFinalUserData(appuntamento.utente);
                    }*/
                    //I clienti a cui manca almeno un dato devono inserirli tutti
                    if (
                      appuntamento
                      && appuntamento.utente
                      && (
                        (!appuntamento.utente.nome || appuntamento.utente.nome == "")
                        || (!appuntamento.utente.cognome || appuntamento.utente.cognome == "")
                        || (!appuntamento.utente.email || appuntamento.utente.email == "")
                        || (!appuntamento.utente.telefono || appuntamento.utente.telefono == "")
                        || ((!appuntamento.utente.cap || appuntamento.utente.cap == "") && appuntamento.tipologia != "Agenzia/PV C5")
                      )
                    ) {
                      appuntamento.utente = {
                        nome: "",
                        cognome: "",
                        email: "",
                        telefono: "",
                        cap: "",
                        cancella_dati_locali: true
                      }
                      self.props.setDatiPersonali(appuntamento.utente);
                    }
  
                    if (self.userDataExists(appuntamento)) {
                      self.retrieveUserData(appuntamento);
                    }

                    if (self.appointmentDataExists(appuntamento)) {
                      self.retrieveOldAppointment(appuntamento);
                    }

                    if (self.userDataExists(appuntamento) && self.appointmentDataExists(appuntamento)) {
                      handleFlow();
                    } else {
                      let userDataExists = false;

                      if (self.userDataExists(appuntamento)) {
                        self.props.setRecap(false);
                        userDataExists = true;
                      }

                      self.props.setFlowSwitch({
                        goToNextStepAutomatically: true,
                        previousFlow: global_state.prodotto,
                      });
            
                      this.setRecapAreaVisibility(1);
                      
                      switchToPrestitoPersonale({
                        fromStart: true,
                        disableRedirect: true,
                        userDataExists
                      });
                    }
                  }
                }
              },
              (error) => {}
            );
          }
        }
      }
    });
  }

  handleLocation = (city, location, lat, lng) => {
    this.props.setDove({
      'luogo': location,
      'coordinate_luogo': {
        'lat': lat,
        'lng': lng
      }
    });

    this.trovaFiliali(location, lat, lng);

    /* Google Tag Manager - Handle dataLayer push */
    handleLocationInteraction(city);
    /* End Google Tag Manager - Handle dataLayer push */

    handleFlow();
  }

  handleToggle = () => {
    if (!(this.state.isOpen)) {
      this.setState({ isOpen: true });
    }
  }

  handleSubmit = (event) => {
    event.preventDefault();
    let address = event.target.cerca.value;
    let self = this;
    let search = window.document.getElementById("search");
    // let excluded = window.excluded;
    const excluded = excludedCapsMock;

    if (
      search && excluded.indexOf(search.value) != -1
    ) { //Se hai inserito uno dei CAP esclusi vai diretto a CF
      enterInSpecificFlow(-1);
      return false;
    }
    // if (gState.prodotto == 3) { //CAP ESCLUSI
    //   // utils.getCurrentStep();
    //   handleFlow();
    //   return false;
    // }
    /* Google Tag Manager - Handle dataLayer push */
    handleLocationInteraction('Ricerca');
    //handleLocationSearch(address);
    /* End Google Tag Manager - Handle dataLayer push */
    if (address && address != "" && address.length > 1) {
      address = translateCap(address);

      let geocoder = new window.mapkit.Geocoder({
        language: "it",
        getsUserLocation: false
      });

      if (address && address.toLowerCase().indexOf("ital")==-1) { //Se non c'è italy
        address = 'Italy, ' + address;
      }

      geocoder.lookup(address, function (err, data) {
        if (data && data.results && data.results.length > 0) {
          const miglior_risultato = data.results[0];
          const cap = miglior_risultato.postCode;
          if (cap && cap != '') {
            handleCap(cap);
          }
          geocoder.reverseLookup(new window.mapkit.Coordinate(miglior_risultato.coordinate.latitude, miglior_risultato.coordinate.longitude), (r_err, r_data) => {
            if (r_data && r_data.results && r_data.results.length>0) {
              const indirizzo = r_data.results[0].formattedAddress;
              if ((!cap || cap == '') && r_data.results[0] && r_data.results[0].postCode) {
                handleCap(r_data.results[0].postCode)
              }
              if (utils.isCapExluded(indirizzo)) { //CAP bloccato
                enterInSpecificFlow(-1)
              } else {
                let lat = r_data.results[0].coordinate.latitude;
                let lng = r_data.results[0].coordinate.longitude;
                self.props.setDove({
                  'luogo': address,
                  'coordinate_luogo': {
                    'lat': lat,
                    'lng': lng
                  }
                });
                self.trovaFiliali(address, lat, lng, cap, {
                  goToNextPage: true
                })
              }
            } else {
              utils.showErrorModal("Indirizzo non trovato");
            }
          });
        } else {
          utils.showErrorModal("Indirizzo non trovato");
        }
      });

      /*var geocoder = new window.google.maps.Geocoder;
      geocoder.geocode({ 'address': address, 'region': 'it' }, function (results, status) {
        if (status == 'OK') {
          const place = results[0];
          if (utils.isCapExluded(place.formatted_address)) { //CAP bloccato
            self.props.setProdotto(3);

            skipScegliLuogo();
            skipDataAppuntamento();

            self.props.setCapExcluded(true);
          } else {
            let lat = results[0].geometry.location.lat();
            let lng = results[0].geometry.location.lng();
            self.props.setDove({
              'luogo': address,
              'coordinate_luogo': {
                'lat': lat,
                'lng': lng
              }
            });
            self.trovaFiliali(address, lat, lng)
          }
          utils.getCurrentStep();
        } else {
          utils.showErrorModal("Indirizzo non trovato");
        }
      })*/
    } else if (typeof address != "undefined" && address != null && address.length < 2) {
      let errors = this.state.errors;
      errors['cerca'] = 'Inserire un indirizzo e una città';
      this.setState({
        'errors': errors
      });
    }
  }

  handleKeyup() {
    let errors = this.state.errors;
    delete errors.cerca;
    this.setState({
      'errors': errors
    });
  }

  geolocateUser = () => {
    /* Google Tag Manager - Handle dataLayer push */
    //handleLocationInteraction('Localization');
    /* End Google Tag Manager - Handle dataLayer push */


    const location = window.navigator && window.navigator.geolocation
    let self = this;
    if (location) {
      location.getCurrentPosition((position) => {
        /* Google Tag Manager - Handle dataLayer push */
        handleGeolocalization('Attivata');
        /* End Google Tag Manager - Handle dataLayer push */
        var geocoder = new window.google.maps.Geocoder;
        var latlng = { lat: position.coords.latitude, lng: position.coords.longitude };
        if (position && position.coords && position.coords.latitude && position.coords.longitude) {
          geocoder.geocode({ 'location': latlng }, function (results, status) {
            if (status === 'OK') {
              if (results[0]) {
                const address = results[0].formatted_address;
                if (address) {

                  self.setState({
                    forced_location: address
                  });
                  window.setTimeout(function () {
                    self.setState({
                      forced_location: ''
                    });
                  }, 1000);

                  handleFlow();
                }
              } else {
                window.alert('No results found');
              }
            } else {
              window.alert('Geocoder failed due to: ' + status);
            }
          });
        }
      }, (error) => {
        handleGeolocalization('Bloccata');
        this.setState({
          'appuntamentoNonTrovatoVisibile': true
        })
        this.setState({ latitude: 'err-latitude', longitude: 'err-longitude' })
      })
    }
  }

  closeModalGenerica() {
    this.setState({
      'appuntamentoNonTrovatoVisibile': false
    })
    //window.document.getElementById("cf_field").value='asd'
  }

  render() {
    return (
      <div>
        <Stepper percentage="40" />
        <ModalError />
        <ModalBoxGenerico handler={this.closeModalGenerica} testo="Localizzazione bloccata scegli tra le città proposte o cerca la tua città" visible={this.state.appuntamentoNonTrovatoVisibile} buttontext="OK" />
        <div className="grid-container" id="dove">
          <RecapArea visible={ this.state.recapAreaVisibility } />
          <div className="grid-x grid-padding-x">
            <div className="cell animations-container">
              <h2 className="hasSubtitle gsap-fade">Dove vuoi fissare l'appuntamento?</h2>
              <CTA />
              <ToggleContainer title={ this.state.toggleContainerTitle } type="cerca" submiterror={this.state.errors.cerca} isOpen={true} handleKeyup={this.handleKeyup} handleToggle={this.handleToggle} handleSubmit={this.handleSubmit} forced_location={this.state.forced_location} />
              {/*<h4 className="gsap-fade citta">Oppure inizia scegliendo una citt&agrave;:</h4>
              <CustomButton value="Milano" handler={() => this.handleLocation('Milano', 'Milano - 20100', '45.466797', '9.190498')} />
              <CustomButton value="Roma" handler={() => this.handleLocation('Roma', 'Roma - 00100', '41.894802', '12.485338')} />
              <CustomButton value="Napoli" handler={() => this.handleLocation('Napoli', 'Napoli - 80100', '40.835934', '14.248783')} />
              <CustomButton value="Palermo" handler={() => this.handleLocation('Palermo', 'Palermo - 90121', '38.111227', '13.352443')} />
              <CustomButton value="Firenze" handler={() => this.handleLocation('Firenze', 'Firenze - 50100', '43.769871', '11.255576')} />*/}
            </div>
          </div>
          <div id="scelte_aggiuntive">
            <div className="grid-x grid-padding-x">
              <div className="cell small-12 vicino">
                <button className="underlined gsap-fade" onClick={this.geolocateUser}>Vicino a me</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default connect(null, mapDispatchToProps)(Dove);


// WEBPACK FOOTER //
// ./src/components/dove/index.js